import { SearchOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import SearchComponent from 'components/Global/SearchComponent';
import { paymentOptions } from 'utils/utils';
import styles from './index.module.scss';
type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => Promise<void>;
	StatusFilter: string;
	handleStatusFilter: (value: string) => void;
};

const NapsaLogHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		StatusFilter,
		handleStatusFilter,
	} = props;

	return (
		<div className={styles['napsaLog-header']}>
			<Space>
				<SearchComponent
					className={styles['napsaLog-header-item']}
					placeHolder="Search here..."
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<Select
					style={{ minHeight: '43px' }}
					className={styles['napsaLog-header-item']}
					value={StatusFilter}
					options={paymentOptions}
					onChange={(value) => handleStatusFilter(value)}
					size="large"
					placeholder="Select Status"
				/>
			</Space>
		</div>
	);
};

export default NapsaLogHeader;
